"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t();

function render(input, out) {
  var data = input;
}

marko_template._ = render;
